<script>
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import { fade } from "svelte/transition";
  import AXHR from "../components/js/axhr.js";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  import QrCode from "svelte-qrcode";
  //TABLE SECTION
  import prettyB from "pretty-bytes";
  import format from "number-format.js";

  $: dataProfiles = [];
  function loadDataProfiles(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        let res;
        res = response.data;
        if (filter !== false) {
          res = res.filter((el) => {
            return el[filter.name] !== filter.value;
          });
        } else {
          res = res;
        }
        dataProfiles = res;
        console.log(dataProfiles);
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  function onLoginDetail(prof, get, pure = false) {
    let strings = dataProfiles.filter((el) => {
      return el["name"] == prof;
    })[0]["onLogin"];
    if (strings) {
      strings = strings.split(",");

      if (get == 1) {
        if (pure == true) {
          strings = strings[1];
        } else {
          if (strings[1] == "rem") {
            strings = "Remove";
          } else if (strings[1] == "ntf") {
            strings = "Notice";
          } else if (strings[1] == "remc") {
            strings = "Remove & Record";
          } else if (strings[1] == "ntfc") {
            strings = "Notice & Record";
          } else {
            strings = "";
          }
        }
      } else if (get == 2) {
        strings = strings[2];
      } else if (get == 3) {
        strings = strings[3];
      } else if (get == 4) {
        strings = strings[4];
      } else if (get == 5) {
        strings = strings[5];
      }
    } else {
      strings = "";
    }

    return strings;
  }

  function splitStrings(strings, get, pure = false) {
    strings = strings.split(",");
    if (get == 1) {
      if (pure == true) {
        strings = strings[1];
      } else {
        if (strings[1] == "rem") {
          strings = "Remove";
        } else if (strings[1] == "ntf") {
          strings = "Notice";
        } else if (strings[1] == "remc") {
          strings = "Remove & Record";
        } else if (strings[1] == "ntfc") {
          strings = "Notice & Record";
        } else {
          strings = "";
        }
      }
    } else if (get == 2) {
      strings = strings[2];
    } else if (get == 3) {
      strings = strings[3];
    } else if (get == 4) {
      strings = strings[4];
    } else if (get == 5) {
      strings = strings[5];
    }
    return strings;
  }

  $: dataFiltered = [];
  function loadData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        let res;
        res = response.data;
        if (filter !== false) {
          res = res.filter((el) => {
            return el[filter.name] === filter.value;
          });
        } else {
          res = res;
        }
        dataFiltered = res;
        loadTable = true;
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  if (sessions) {
    loadDataProfiles(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-user-profile",
      sessions.token,
      false
    );
  }

  function expStatus(params) {
    if (params == "1s") {
      return "Expired";
    } else {
      return "OK";
    }
  }
  let loadTable = false;

  import MakeSortable from "../components/MakeTable/MakeSortable.svelte";
  import SortHeader from "../components/MakeTable/SortHeader.svelte";
  let filter = "",
    imgsortIconCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>',
    imgsortIconAscCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path></svg>',
    imgsortIconDescCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" /></svg>';
</script>

<svelte:head>
  <title>Mikhub - Hotspot User Printing</title>
</svelte:head>
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-24 mx-auto mb-20 lg:pt-24 md:pt-20"
>
  <Title
    title="Hotspot Voucher"
    subtitle="Print Vouchers Easily"
    tipe="3"
    href="./"
  />

  {#if loadTable}
    <MakeSortable
      rowsPerPage="1000"
      data={dataFiltered}
      let:table
      {filter}
      filterFields={[
        "addressPool",
        "name",
        "parentQueue",
        "rateLimit",
        "sharedUsers",
        "onLogin",
        "comment",
        "limitUptime",
      ]}
      sortIconCss={imgsortIconCss}
      sortIconAscCss={imgsortIconAscCss}
      sortIconDescCss={imgsortIconDescCss}
    >
      <div class="flex flex-wrap items-center justify-between w-full my-2">
        <div class="flex justify-start w-1/2 gap-2 py-1 lg:w-4/12 md:w-2/6">
          <div class="mt-0 lg:mt-0 md:mt-4">
            <button
              on:click={() => (loadTable = false)}
              class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
              ><svg
                class="inline w-4 h-4"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  points="3.828 9 9.899 2.929 8.485 1.515 0 10 .707 10.707 8.485
                  18.485 9.899 17.071 3.828 11 20 11 20 9 3.828 9"
                />
              </svg> Back</button
            >
          </div>
          {#if table.pageRows.length > 0}
            <div class="mt-0 lg:mt-0 md:mt-4">
              <button
                on:click={() => window.print()}
                class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
                ><svg
                  class="inline w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                  />
                </svg>
                Print</button
              >
            </div>
          {/if}
        </div>
        <div
          class="flex items-center justify-end w-1/2 gap-4 px-2 py-1 text-xs lg:w-4/12 md:w-2/6"
        >
          <span>Total : <b>{table.rows.length}</b></span><span
            >Filtered : <b>{table.sortedAndFilteredRows.length}</b></span
          >
        </div>
        <input
          type="text"
          class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
          placeholder="Search..."
          bind:value={filter}
        />
      </div>
      <div class="flex flex-wrap items-center justify-between w-full mb-2">
        {#if table.pageRows.length > 0}
          <div class="flex flex-wrap w-full" id="kpt">
            {#each table.pageRows as d, i}
              <div
                class="relative w-1/2 p-px mb-2 lg:w-1/5 md:w-1/5 sm:w-1/5 vc"
              >
                <div
                  class="w-full overflow-hidden bg-white border-2 border-gray-600 border-dotted rounded-lg"
                >
                  <div class="relative flex flex-wrap w-full">
                    <div class="w-6/12 px-2">
                      <h2 class="font-bold text-gray-900 text-md">
                        {#if sessions.routeractive.logo}
                          <img
                            src="{sessions.api}/logo/{sessions.routeractive
                              .logo}"
                            alt={sessions.routeractive.name}
                            class="w-full"
                          />
                        {:else}
                          {sessions.routeractive.name}
                        {/if}
                      </h2>
                    </div>
                    <div class="w-6/12 text-right">
                      <span
                        class="inline-block px-1 py-0 text-xs italic font-bold text-gray-800 bg-gray-100 border border-r-0 border-gray-500 rounded-l-lg"
                      >
                        {format("Rp#.##0,", onLoginDetail(d.profile, 4))}
                        <span /></span
                      >
                    </div>
                  </div>
                  <div class="relative flex flex-wrap w-full h-24">
                    <div class="w-8/12 px-2 text-xs">
                      <h3 class="text-xs font-bold">
                        <span class="italic font-normal">Valid for</span>

                        {#if onLoginDetail(d.profile, 3) !== ""}
                          {onLoginDetail(d.profile, 3)}
                        {:else}
                          Forever
                        {/if}
                      </h3>
                      <h3 class="text-xs font-bold">
                        {#if d.limitBytesTotal}
                          {prettyB(d.limitBytesTotal)}
                        {:else}
                          Unlimited
                        {/if}
                        <span class="italic font-normal">Quota </span>
                      </h3>
                      {#if d.password !== d.name}
                        <h4
                          class="px-1 font-mono text-sm font-bold text-center text-black bg-white border border-gray-900 border-dashed rounded"
                        >
                          {String(d.name)}
                        </h4>

                        <h4
                          class="px-1 mt-px font-mono text-sm font-bold text-center text-black bg-white border border-gray-500 border-dashed rounded"
                        >
                          {String(d.password)}
                        </h4>
                      {:else}
                        <h4
                          class="flex items-center justify-center px-1 font-mono text-sm font-bold leading-3 text-center text-black bg-white border border-gray-900 border-dashed rounded h-7"
                        >
                          {String(d.name)}
                        </h4>
                      {/if}
                    </div>
                    <div
                      class="flex items-center justify-end w-4/12 p-1 bg-white rounded"
                    >
                      <QrCode
                        value="http://{sessions.routeractive
                          .dns}/login?username={d.name}&password={d.password}"
                        size="256"
                      />
                    </div>
                  </div>

                  <div
                    class="w-full h-5 px-2 text-xs italic leading-3 text-gray-900 truncate"
                  >
                    login : http://{sessions.routeractive.dns}
                  </div>
                  <div
                    class="relative flex flex-wrap w-full mt-px bg-gray-100 border-t border-gray-400 border-dashed"
                  >
                    <div
                      class="items-center w-full h-4 px-2 py-0 text-xs italic text-gray-900 truncate whitespace-pre-wrap"
                    >
                      <h4>[{i + 1}] {String(d.comment)}</h4>
                    </div>
                  </div>
                </div>
              </div>
            {/each}
          </div>
        {:else}
          {#if filter}
            <div class="flex items-center justify-center w-full h-full">
              <div class="text-center">
                <span class="italic text-gray-900 animate-pulse text-md"
                  >Data Not Found</span
                >
              </div>
            </div>
          {:else}
            <div class="flex items-center justify-center w-full h-full">
              <div class="text-center">
                <span class="italic text-gray-900 animate-pulse text-md"
                  >Data Not Found</span
                >
              </div>
            </div>
          {/if}

          <div class="flex items-center justify-center w-full h-full">
            <div class="text-center">
              <img
                src="./assets/logo/logo_icon.svg"
                alt="Mikhub Loading"
                class="w-20 h-20 mx-auto animate-spin"
                width="50"
                height="50"
              />
            </div>
          </div>
        {/if}
      </div>
    </MakeSortable>
  {:else}
    <MakeSortable
      data={dataProfiles}
      let:table
      {filter}
      filterFields={[
        "addressPool",
        "name",
        "parentQueue",
        "rateLimit",
        "sharedUsers",
        "onLogin",
      ]}
      sortIconCss={imgsortIconCss}
      sortIconAscCss={imgsortIconAscCss}
      sortIconDescCss={imgsortIconDescCss}
    >
      <div class="flex flex-wrap items-center justify-between w-full pr-2 mb-2">
        <div class="flex justify-start w-1/2 gap-2 py-1 lg:w-4/12 md:w-2/6">
          <div class="mt-0 lg:mt-0 md:mt-4">
            <button
              on:click={() =>
                loadDataProfiles(
                  sessions.api +
                    "/rb/" +
                    sessions.routeractive.id +
                    "/ip-hotspot-user-profile",
                  sessions.token,
                  { name: "default", value: true }
                )}
              class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
              ><svg
                class="inline w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg> Refresh</button
            >
          </div>
        </div>
        <div
          class="flex items-center justify-end w-1/2 gap-4 px-2 py-1 text-xs lg:w-4/12 md:w-2/6"
        >
          <span>Total : <b>{table.rows.length}</b></span><span
            >Filtered : <b>{table.sortedAndFilteredRows.length}</b></span
          >
        </div>
        <input
          type="text"
          class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
          placeholder="Search..."
          bind:value={filter}
        />
      </div>

      <div class="w-full">
        <div
          class="sticky z-10 w-full mb-5 bg-gray-100 border-b-4 border-gray-400 rounded-lg shadow-lg lg:shadow-lg md:shadow-lg lg:top-20 md:top-20 top-16"
        >
          <div
            class="flex flex-no-wrap items-end justify-start w-full overflow-x-auto text-center cursor-pointer lg:items-center md:items-end"
          >
            <SortHeader
              css="w-48 p-2 text-sm font-bold italic"
              path={(row) => String(row.name)}>Profile Name</SortHeader
            >
            <SortHeader
              css="w-16 p-2 text-sm font-bold italic"
              path={(row) => String(row.sharedUsers)}>Slot</SortHeader
            >
            <SortHeader
              css="w-24 p-2 text-sm font-bold italic"
              path={(row) => format("Rp#.##0,00", splitStrings(row.onLogin, 2))}
              >Price</SortHeader
            >
            <SortHeader
              css="w-24 p-2 text-sm font-bold italic"
              path={(row) => format("Rp#.##0,00", splitStrings(row.onLogin, 4))}
              >Sell Price</SortHeader
            >
            <SortHeader
              css="w-26 p-2 text-sm font-bold italic"
              path={(row) => String(row.rateLimit)}>Rate Limit</SortHeader
            >

            <SortHeader
              css="w-24 p-2 text-sm font-bold italic"
              path={(row) => splitStrings(row.onLogin, 3)}>Expired</SortHeader
            >

            <SortHeader
              css="w-40 p-2 text-sm font-bold italic"
              path={(row) => splitStrings(row.onLogin, 3)}>Mode</SortHeader
            >
          </div>
        </div>

        <div class="flex flex-wrap">
          {#if table.pageRows.length > 0}
            {#each table.pageRows as p}
              <div
                class="w-full p-0 pb-2 lg:p-2 md:p-2 lg:w-1/4 md:w-1/3"
                on:click={() =>
                  loadData(
                    sessions.api +
                      "/rb/" +
                      sessions.routeractive.id +
                      "/ip-hotspot-user",
                    sessions.token,
                    { name: "profile", value: p.name }
                  )}
              >
                <div
                  class="flex items-start justify-between px-4 py-3 text-left bg-gray-100 rounded-md shadow cursor-pointer hover:bg-white hover:shadow-outline"
                >
                  <div
                    title="Click To Connect"
                    class="w-full text-base text-gray-800"
                  >
                    <b>{p.name}</b><br />

                    <div
                      class="w-full mx-0 my-2 overflow-hidden rounded-lg hover:shadow-lg lg:my-1 md:my-1"
                    >
                      <div
                        class="flex flex-wrap items-center justify-start w-full"
                      >
                        <div class="w-16 p-2 text-sm">
                          <div class="block font-mono text-xs italic">Slot</div>
                          {#if p.sharedUsers}
                            {String(p.sharedUsers)}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div class="block font-mono text-xs italic">
                            Price
                          </div>
                          {#if p.onLogin}
                            {#if splitStrings(p.onLogin, 4) > 0}
                              {format("Rp#.##0,", splitStrings(p.onLogin, 4))}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div class="block font-mono text-xs italic">
                            Sale Price
                          </div>
                          {#if p.onLogin}
                            {#if splitStrings(p.onLogin, 4) > 0}
                              {format("Rp#.##0,", splitStrings(p.onLogin, 4))}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="p-2 text-sm w-28">
                          <div class="block font-mono text-xs italic">
                            Rate Limit
                          </div>
                          {#if p.rateLimit}
                            {p.rateLimit}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div class="block font-mono text-xs italic">
                            Expired
                          </div>
                          {#if p.onLogin}
                            {#if splitStrings(p.onLogin, 3)}
                              {splitStrings(p.onLogin, 3)}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-40 p-2 text-sm">
                          <div class="block font-mono text-xs italic">Mode</div>
                          {#if p.onLogin}
                            {#if splitStrings(p.onLogin, 1)}
                              {splitStrings(p.onLogin, 1)}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {:else}
              <div class="flex items-center justify-center w-full h-full">
                <div class="text-center">
                  <img
                    src="./assets/logo/logo_icon.svg"
                    alt="Mikhub Loading"
                    class="w-20 h-20 mx-auto animate-spin"
                    width="50"
                    height="50"
                  />
                  <span class="italic text-gray-900 animate-pulse text-md"
                    >loading</span
                  >
                </div>
              </div>
            {/each}
          {:else}
            {#if filter}
              <div class="flex items-center justify-center w-full h-full">
                <div class="text-center">
                  <span class="italic text-gray-900 animate-pulse text-md"
                    >Data Not Found</span
                  >
                </div>
              </div>
            {:else}
              <div class="flex items-center justify-center w-full h-full">
                <div class="text-center">
                  <span class="italic text-gray-900 animate-pulse text-md"
                    >Data Not Found</span
                  >
                </div>
              </div>
            {/if}

            <div class="flex items-center justify-center w-full h-full">
              <div class="text-center">
                <img
                  src="./assets/logo/logo_icon.svg"
                  alt="Mikhub Loading"
                  class="w-20 h-20 mx-auto animate-spin"
                  width="50"
                  height="50"
                />
              </div>
            </div>
          {/if}
        </div>
      </div>
      <div
        class="flex flex-no-wrap items-center justify-center w-full my-5 rounded-lg"
      >
        <div
          class="flex items-center justify-center w-10 h-10 bg-white rounded-l-lg shadow"
          class:bg-gray-300={table.paging.currentPage === 0}
        >
          <button
            class="w-full h-full focus:outline-none"
            on:click={table.paging.onPrevious}>&laquo;</button
          >
        </div>
        {#each table.paging.buttons as btn (btn)}
          <div
            class="flex items-center justify-center w-10 h-10 bg-white shadow"
            class:bg-gray-300={btn.active}
          >
            <button
              class="w-full h-full focus:outline-none"
              on:click={btn.onClick}>{btn.label}</button
            >
          </div>
        {/each}
        <div
          class="flex items-center justify-center w-10 h-10 bg-white rounded-r-lg shadow"
          class:bg-gray-300={table.paging.currentPage >=
            table.paging.pageCount - 1}
        >
          <button
            class="w-full h-full focus:outline-none"
            on:click={table.paging.onNext}>&raquo;</button
          >
        </div>
      </div>
    </MakeSortable>
  {/if}
</main>
